"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoryPage = void 0;
var _mui = require("@ori-ui/mui");
var _editorialComponents = require("@ori/editorial-components");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../hooks/useTranslations");
var _CategoryPageSkeleton = require("../CategoryPageSkeleton");
var _styles = require("../LandingPage/styles");
var _categoryPageClasses = require("./categoryPageClasses");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component that renders content on editorial category page.
 */ const CategoryPage = (param)=>{
    let { breadcrumbs, data, preview, className } = param;
    const theme = (0, _mui.useTheme)();
    const { formatMessage, translations } = (0, _useTranslations.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    const getPaginationInfoText = (0, _react.useCallback)((value, max)=>formatMessage('showingXOutOfYProducts', {
            value,
            max
        }), [
        formatMessage
    ]);
    const { editorialLandingPage } = data !== null && data !== void 0 ? data : {};
    if (!editorialLandingPage) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CategoryPageSkeleton.CategoryPageSkeleton, {
            className: className
        });
    }
    const { themeTag, description, editorialItems, imageUrl, backgroundStorybookColor, themeItems } = editorialLandingPage;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.CATEGORY_PAGE),
        className: className,
        children: [
            preview ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.Alert, {
                color: "success",
                severity: "info",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    children: "PREVIEW MODE"
                })
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.TopBanner, {
                breadcrumbs: breadcrumbs,
                imageUrl: imageUrl,
                backgroundColor: (0, _presentationUtils.mapBackendColorToTheme)({
                    theme,
                    backendColor: backgroundStorybookColor,
                    fallBackColor: theme.palette.common.white
                }),
                textColor: theme.palette.text.primary,
                title: themeTag,
                className: _categoryPageClasses.categoryPageClasses.topBanner
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Description, {
                description: description,
                className: _categoryPageClasses.categoryPageClasses.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.ArticlesSectionWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.ArticlesSection, {
                    articles: editorialItems,
                    countOfArticles: editorialItems === null || editorialItems === void 0 ? void 0 : editorialItems.length,
                    labelRead: translations.readNow,
                    loadMoreButtonText: translations.loadMore,
                    mode: "listing",
                    title: "",
                    getPaginationInfoText: getPaginationInfoText,
                    className: _categoryPageClasses.categoryPageClasses.articlesSection
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Inner, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.CategoriesSection, {
                    categories: themeItems,
                    title: translations.otherCategories,
                    viewButtonText: translations.view,
                    className: _categoryPageClasses.categoryPageClasses.categoriesSection
                })
            })
        ]
    });
};
exports.CategoryPage = CategoryPage;
